import script from "./AddSectionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSectionDialog.vue?vue&type=script&setup=true&lang=js"

import "./AddSectionDialog.vue?vue&type=style&index=0&id=57742070&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57742070"]])

export default __exports__